import { ref } from 'vue';

export type AuthStep = 'email' | 'login' | 'signup' | 'otp' | 'phoneSignup' | 'phoneLogin' | 'phoneOtp';

export const authEmail = ref('');
export const authPhoneNumber = ref('');
export const authStep = ref<AuthStep>('email');
export const userHasPassword = ref(false);
/** Step to return to when user cancels OTP verify */
export const otpReturnStep = ref<AuthStep>('login');

export function goToEmailStep() {
    authStep.value = 'email';
}

export function resetAuthFlow() {
    authStep.value = 'email';
    authEmail.value = '';
    authPhoneNumber.value = '';
    userHasPassword.value = false;
    otpReturnStep.value = 'login';
}
